//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'NonalcoholicFattyLiver',
  data() {
    return {
      defaultJson:{
        "Age": "年龄",
        "Body Mass Index": "体重指数",
        "Serum AST": "门冬氨酸氨基转移酶（AST）",
        "Serum ALT": "丙氨酸氨基转移酶（ALT）",
        "Serum albumin": "血清白蛋白（Alb）",
        "Platelet count": "血小板（PLT）",
        "Diabetes or impaired fasting blood sugar": "糖尿病或空腹血糖受损"
      },
      form:{
        age:'',
        weight:'',
        ast:'',
        alt:'',
        albumin:'',
        plate_count:'',
        sugar:'0',
      },
      hasScore:false,
      disabled:false
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        console.log(form)
        // 评分=-1.675+0.037×年龄+0.094×BMI+（1.13如有糖尿病）+0.99×（AST/ALT）-0.013×PLT-0.66×Alb
        let result = -1.675 + 0.037 * form.age + 0.094 * form.weight + (form.sugar == '1' ? 1.13 : 0) + 0.99 * (form.ast / form.alt) - 0.013 * form.plate_count-0.66 * form.albumin
        self.hasScore = true
        return String(result.toFixed(3))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GIT/NonalcoholicFattyLiver.vue